import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case Types.PORTAL_ERROR:
            return {
                ...state,
                portalError: action.portalError
            }
        case Types.SET_PORTAL_LOGO:
            return {
                ...state,
                selectedPortalLogo: action.selectedPortalLogo,
                portalLogoName: action.portalLogoName
            }
        case Types.CURRENT_PORTAL:
            return {
                ...state,
                currentPortal: action.data
            }
        default:
            return state
    }
}